 
// TableComponent.jsx
import { Container, Table } from "react-bootstrap";
import { formatDate } from "../Utils/helpers/commonhelper";
import DeleteModal from "./DeleteModal";
import { TableSkeleton } from "../Utils/skeletonLoader/TableSkeleton";
import nodata from "../Utils/assets/img/leads_no_data_found.png";
export const TableComponent = ({
  data = [],
  columns = [],
  columnLabels = {},
  customRenderers = {},
  actions = null,
  showDeleteModal = false,
  onDeleteClose,
  onDeleteConfirm,
  isLoading,
  startidx,
  loading,
}) => {
  return (
    <>
      <Container
        fluid
        style={{
          fontFamily: "'Poppins', sans-serif",
          height: "calc(100vh - 10rem)",
          backgroundColor: "white",
          padding: 0,
          animation: "cardEntry 1s ease-out forwards",
        }}
        className="mt-3 p-0"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          }}
        >
          <style>
            {`
                .listStyleForContact::-webkit-scrollbar {
                    width: 6px;
                }
                .listStyleForContact::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 10px;
                }
                .listStyleForContact::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 10px;
                }
                .listStyleForContact::-webkit-scrollbar-thumb:hover {
                    background: #a8a8a8;
                }
            `}
          </style>
 
          <div
            className="listStyleForContact container-table"
            style={{
              flex: columns?.length > 10 ? 1 : "auto",
              overflow: "auto",
              width: "100%",
              maxHeight: columns?.length > 10 ? "100%" : "auto",
            }}
          >
            <Table style={{
              width: "100%",
              tableLayout: "auto",
              backgroundColor: "white",
              marginBottom: "0px",
            }}>
              <thead className="table-light" style={{ zIndex: "10" }}>
                <tr className="table table-bordered">
                  <th style={{ backgroundColor: "#7a3a5e", color: "black" }}>SR.</th>
                  {columns.map((col) => (
                    <th
                      key={col}
                      style={{ backgroundColor: "#7a3a5e", textTransform: "capitalize", color: "black" }}
                    >
                      {columnLabels[col] || col.replace(/_/g, " ")}
                    </th>
                  ))}
 
                  {actions && <th style={{ backgroundColor: "#7a3a5e", textTransform: "capitalize", color: "black" }}>Actions</th>}
                </tr>
              </thead>
              {loading ? (
                <TableSkeleton columnCount={ columnLabels?.full_name ? 6 : columnLabels?.team_name ? 5:3} />
              ) : (
                <>
                  <tbody>
                    {data.length > 0 ? (
                      data.map((row, index) => (
                        <tr key={row.id || index}>
                          <td>{startidx++ || index + 1}</td>
                          {columns.map((col) => (
                            <td
                              key={col}
                              style={{
                                maxWidth: "120px",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                cursor: "pointer"
                              }}
                            >
                              <span
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={row[col]}
                                className="custom-tooltip"
                              >
                                {customRenderers?.[col] ? customRenderers[col](row) : col === "created_at" ? formatDate(row[col]) : row[col]}
                              </span>
                            </td>
                          ))}
                          {actions && (
                            <td>
                              <div className="d-flex align-items-center gap-2 flex-wrap">
                                {actions(row, index)}
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={columns.length + 2}
                          className="text-center py-4"
                        >
                          <img
                            src={nodata}
                            alt=""
                            style={{ width: "17rem", marginTop: "0" }}
                          />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </>
              )}
            </Table>
          </div>
        </div>
      </Container>
      {showDeleteModal && (
        <DeleteModal
          show={showDeleteModal}
          onClose={onDeleteClose}
          onConfirm={onDeleteConfirm}
          isLoading={isLoading}
          message="Are you sure you want to permanently delete this item?"
        />
      )}
    </>
  );
};
 